import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-of-treatments',
  templateUrl: './list-of-treatments.component.html',
  styleUrls: ['./list-of-treatments.component.scss']
})
export class ListOfTreatmentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
